import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("table", {
    cellspacing: "0",
    cellpadding: "0",
    class: _normalizeClass(["el-date-table", { 'is-week-mode': _ctx.selectionMode === 'week' }]),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args))),
    onMousemove: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleMouseMove && _ctx.handleMouseMove(...args)))
  }, [
    _createElementVNode("tbody", null, [
      _createElementVNode("tr", null, [
        (_ctx.showWeekNumber)
          ? (_openBlock(), _createElementBlock("th", _hoisted_1, _toDisplayString(_ctx.t('Controls.DatePicker.Week')), 1))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.WEEKS, (week, key) => {
          return (_openBlock(), _createElementBlock("th", { key: key }, _toDisplayString(_ctx.t('Controls.DatePicker.Weeks.' + week)), 1))
        }), 128))
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row, key) => {
        return (_openBlock(), _createElementBlock("tr", {
          key: key,
          class: _normalizeClass(["el-date-table__row", { current: _ctx.isWeekActive(row[1]) }])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (cell, key_) => {
            return (_openBlock(), _createElementBlock("td", {
              key: key_,
              class: _normalizeClass(_ctx.getCellClasses(cell))
            }, [
              _createElementVNode("div", null, [
                _createElementVNode("span", null, _toDisplayString(cell.text), 1)
              ])
            ], 2))
          }), 128))
        ], 2))
      }), 128))
    ])
  ], 34))
}